var _div, _CourseCardSkeleton;
import { useMediaQuery } from '@crehana/react-hooks';
import { CourseCardSkeleton, GridScroll } from "../../../../../components";
import { jsx as _jsx } from "react/jsx-runtime";
export var MainCategoriesContentSkeleton = function MainCategoriesContentSkeleton(_ref) {
  var className = _ref.className;
  var _useMediaQuery = useMediaQuery('sm'),
    isUpSm = _useMediaQuery.matches;
  var renderCard = function renderCard(_, index) {
    return /*#__PURE__*/_jsx(CourseCardSkeleton, {}, index);
  };
  if (!isUpSm) {
    return _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-pr-1.6 tw-mb-1.6",
      children: /*#__PURE__*/_jsx(CourseCardSkeleton, {})
    }));
  }
  return /*#__PURE__*/_jsx(GridScroll, {
    items: Array.from({
      length: 3
    }).map(renderCard),
    className: className,
    children: _CourseCardSkeleton || (_CourseCardSkeleton = /*#__PURE__*/_jsx(CourseCardSkeleton, {}))
  });
};